import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from "react-router-dom";
import { toast } from "react-toastify";
import {useForm} from "react-hook-form";
import AdminCashierAPI from "../../../../apis/adminApi/AdminCashierAPI";
import Field from "../../../forms/Field";
import MyButton from "../../../assets/MyButton";

const AdminAddCompte = () => {
    const { formState } = useForm();
    const { isSubmitting } = formState;
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(false);

    const [compte, setCompte] = useState({
        compte : "", code: ""
    });

    const [errors, setErrors] = useState({
        compte : "", code: ""
    });

    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCompte({...compte, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{
            setShowLoader(true);
            await AdminCashierAPI.storeCashAccount(compte);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Le compte caisse ajouté avec succès");
            navigate("/admin/cashier/comptes");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire !");
            }
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <h5 className="card-title">Ajouter un compte caise</h5>
                                <div className="row">
                                    <div className="col-10">
                                        <Field
                                            name="compte"
                                            error={errors.compte}
                                            value={compte.compte}
                                            onChange={handleChange}
                                            label="Nom du compte caisse"
                                            placeholder="..."
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-10">
                                        <Field
                                            name="code"
                                            error={errors.code}
                                            value={compte.code}
                                            onChange={handleChange}
                                            label="Code"
                                            placeholder="Code"
                                        />
                                    </div>
                                </div>


                                <MyButton
                                    text="Ajouter"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to="/admin/cashier/comptes" className="btn btn-info mx-2">Revenir aux compte caisse</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminAddCompte;
